/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/subscribe-ui-event/~/lodash/_freeGlobal.js
// module id = 615
// module chunks = 0